import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { withRights } from '../../../../../providers/RightsConsumer';
import { TableContainer, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Button } from '@totalsoft/rocket-ui';
import DocumentScoringCategoryRowComponent from './DocumentScoringCategoryRowComponent';

export const DocumentScoringCategoryListComponent = ({
  categoryList,
  categoryOptions,
  rights,
  saving,
  disabled,
  isHistory,
  onSave,
  onPropertyItemChange,
  viewScoringDetailLimits,
  scoringGridCategoryScoreRead
}) => {
  const { t } = useTranslation();

  const handleSave = () => {
    onSave();
  };

  const handlePropertyItemChange = idx => (prop, value) => {
    onPropertyItemChange(idx, prop, value);
  };

  const isDirty = categoryList.some(x => x.dirtyInfo.isDirty);

  return (
    <Fragment>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('DocumentEdit.Scoring.ScoringCategory.Criterion')}</TableCell>
              <TableCell>{t('DocumentEdit.Scoring.ScoringCategory.Value')}</TableCell>
              <TableCell>{t('DocumentEdit.Scoring.ScoringCategory.Option')}</TableCell>
              {viewScoringDetailLimits && <TableCell align='right'>{t('DocumentEdit.Scoring.ScoringCategory.MinValue')}</TableCell>}
              {viewScoringDetailLimits && <TableCell align='right'>{t('DocumentEdit.Scoring.ScoringCategory.MaxValue')}</TableCell>}
              {scoringGridCategoryScoreRead && <TableCell align='right'>{t('DocumentEdit.Scoring.ScoringCategory.Score')}</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {categoryList.map((x, idx) => {
              return (
                <DocumentScoringCategoryRowComponent
                  key={idx}
                  category={x.document}
                  onPropertyChange={handlePropertyItemChange(idx)}
                  options={categoryOptions.filter(a => a.scoringCategoryId === x.document.scoringCategoryId)}
                  validationInfo={x.validationInfo || {}}
                  disabled={disabled}
                  viewScoringDetailLimits={viewScoringDetailLimits}
                  scoringGridCategoryScoreRead={scoringGridCategoryScoreRead}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {!isHistory && !rights.isImage && (
        <Button color='primary' onClick={handleSave} disabled={rights.readOnlyFull || saving || !isDirty || disabled}>
          {saving ? t('Saving') : t('Save')}
        </Button>
      )}
    </Fragment>
  );
};

DocumentScoringCategoryListComponent.propTypes = {
  onSave: PropTypes.func.isRequired,
  onPropertyItemChange: PropTypes.func.isRequired,
  categoryList: PropTypes.array.isRequired,
  categoryOptions: PropTypes.array.isRequired,
  rights: PropTypes.object.isRequired,
  saving: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  viewScoringDetailLimits: PropTypes.bool.isRequired,
  scoringGridCategoryScoreRead: PropTypes.bool.isRequired,
  isHistory: PropTypes.bool
};

export default withRights(DocumentScoringCategoryListComponent);
